import { Column, FMColumn } from './model';

import keyBy from 'lodash/keyBy';
import { RelativeLocationDescriptor } from '../breadcrumbs/selectors';
import {
  conversionStatusCol,
  createdCol,
  developerCol,
  genreCol,
  introCol,
  managerCol,
  misleadLevelCol,
  recognitionCol,
  sizeCol,
  tagsCol,
  teamCol,
  updatedCol,
} from './baseTableColumns';

/**
 * showOnLevels:
 * - type: на уровне creative_type (папки типа "video")
 * - inside_type: внутри уровня creative_type (файлы типа "video/HC_whatever_video.mp4")
 * - any: всегда
 */
export type SecondaryColumn = {
  essential: boolean;
  key: Column;
  showOnLevels: ((rl: RelativeLocationDescriptor) => boolean) | true;
  column: FMColumn<any>;
  replacementTitle?: string;
};

export const secondaryColumns: SecondaryColumn[] = [
  {
    essential: true,
    key: Column.conversion_status,
    showOnLevels: (rl) => (rl.onTypeLevel || rl.insideType) && !rl.inCreative,
    column: conversionStatusCol,
  },
  {
    essential: false,
    key: Column.recognition,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: recognitionCol,
  },
  {
    essential: true,
    key: Column.manager,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: managerCol,
  },
  {
    essential: false,
    key: Column.developer,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: developerCol,
  },

  {
    essential: false,
    key: Column.mislead_level,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: misleadLevelCol,
  },
  {
    essential: false,
    key: Column.genre,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: genreCol,
  },
  {
    essential: false,
    key: Column.intro,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: introCol,
  },
  {
    essential: false,
    key: Column.team,
    showOnLevels: (rl) => rl.onTypeLevel,
    column: teamCol,
  },
  {
    essential: false,
    key: Column.size,
    showOnLevels: true,
    column: sizeCol,
  },
  {
    essential: false,
    key: Column.created_at,
    showOnLevels: true,
    column: createdCol,
  },
  {
    essential: false,
    key: Column.updated_at,
    showOnLevels: true,
    column: updatedCol,
  },
  {
    essential: true,
    key: Column.tags,
    showOnLevels: true,
    column: tagsCol,
    replacementTitle: 'Tags',
  },
];

export const secondaryColumnsByKey = keyBy(secondaryColumns, (x) => x.key);
export const essentials = secondaryColumns.filter((x) => x.essential);
